{
  "nl": {
    "choice": {
      "actions": {
        "delete_choice": "Keuze verwijderen",
        "delete_choice_list": "Keuzelijst verwijderen"
      },
      "labels": {
        "not_selected": "Niet geselecteerd",
        "selected": "Geselecteerd"
      },
      "messages": {
        "delete_choice": "Weet je zeker dat je de keuze {title} wil verwijderen?",
        "delete_choice_list": "Weet je zeker dat je de keuzelijst {title} wilt verwijderen?"
      },
      "toasts": {
        "create": "Keuze succesvol aangemaakt",
        "delete": "Keuze succesvol verwijderd",
        "update": "Keuze succesvol gewijzigd"
      }
    }
  }
}
